/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import { toast, cssTransition } from 'react-toastify';
import './toast.scss';

const TOAST_CONFIG = {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    pauseOnFocusLoss: false,
    transition: cssTransition({ duration: 300, enter: 'zoomIn', exit: 'zoomOut' })
};

export const customToast = {

    success(msg) {
        toast.success(msg, { ...TOAST_CONFIG, className: 'bg-success' });
    },
    
    error(msg) {
        toast.error(msg, { ...TOAST_CONFIG, className: 'bg-danger' });
    },
    
    warn(msg) {
        toast.warning(msg, { ...TOAST_CONFIG, className: 'bg-warning' });
    },
    
    info(msg) {
        toast.info(msg, { ...TOAST_CONFIG, className: 'bg-info' });
    },
    
    light(msg) {
        toast(msg, TOAST_CONFIG);
    },
    
    dark(msg) {
        toast.dark(msg, { ...TOAST_CONFIG, className: 'bg-dark' });
    }
};

export const ToasterMessage = (props) => {
    return (
        <div className={`${props.className ? props.className : ''} custom-toaster ${props.type}`}>
            <div className="d-flex align-items-center">
                <div className="icon">
                    {
                        props.type === 'success' ?
                            <i className="far fa-check-circle h5"></i> : ''
                            // props.type === 'danger' ?
                            //     <i className="far fa-check-circle h5"></i> :
                            //     props.type === 'warn' ?
                            //         <i className="far fa-check-circle h5"></i> :
                            //         props.type === 'info' ?
                            //             <i className="fas fa-info-circle h5"></i> : null
                    }
                </div>
                <div className="message h6">
                    {props.message}
                </div>
            </div>
        </div>
    );
}